import { createElement, forwardRef } from 'react';
import { grid } from '../patterns/grid.mjs';
import { splitProps } from '../helpers.mjs';
import { styled } from './factory.mjs';

export const Grid = /* @__PURE__ */ forwardRef(function Grid(props, ref) {
  const [patternProps, restProps] = splitProps(props, grid.propKeys)
  const styleProps = grid.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})